exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cookies{position:fixed;width:calc(100% - 20px);bottom:0;padding:10px;z-index:15;font-size:13px;font-family:Graphik;font-weight:700;color:#fff;background-color:rgba(30,30,30,.8);display:flex;justify-content:center;align-items:center}.cookies span a{display:inline-block;color:#fff}.cookies button{margin-left:10px;min-width:95px;height:30px;background-color:#90dc19;border:0;border-radius:7px;font-family:Graphik-Regular;font-size:13px;color:#fff;outline:0}.cookies button:hover{background-color:#72ae14}.cookies.geo,.cookies.geo button{font-family:Georgian-Regular}.cookies.geo button span{position:relative;top:-1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/cookies/cookies.scss
// module id = 942
// module chunks = 0